<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 class="font-size--24" style="word-break: keep-all">
        당겨받기를 위해 필요한 자료들을 체크하고 있습니다.<br />
      </h1>
      <h3 class="font-size--18 mt-10" style="word-break: keep-all">
        * 카드사 변경까지 모두 끝난 경우에만 모집이 시작됩니다. <br />
        <br />
        * 우리동네크라우드 모집 중에는 당겨받기 신청이 불가능합니다. <br />
      </h3>
    </section>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { commaFormat } from '@/filter/number'
import { locationRedirect } from '@/util'
import { defaultApi } from '@/plugins/api/defaultApi'
import { redirectSignupManage } from '@/util/signupManage'
export default {
  data() {
    return {
      requestLoanLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('document', ['fileObj']),
    ...mapState('contract', ['limitTransaction']),
    ...mapGetters('loan', [
      'isPullRevenueOfferRequest',
      'isLoanAvailableTime',
      'investingPullRevenue',
      'getOffer',
    ]),
    ...mapGetters('evaluation', ['isExpire']),
    offer() {
      return this.getOffer
    }
  },
  watch: {
    offer: {
      immediate: true,
      deep: true,
      handler(newOffer) {
        console.log('Offer updated:', newOffer)
      }
    },
    me: {
      deep: true,
      immediate: true,
      async handler() {
        
      },
    },
  },
  async created() {
    _meta({
      titles: ['당겨받기 준비사항 체크'],
    })


    await this.validateUserRequirements2()

    // 대출서비스이용중 플래그 set 이면 
    const contractCurrent = await this.getCurrent()
    if(contractCurrent?.isLoanEnabled || contractCurrent?.isEarlyPaymentEnabled) {
      await this.createLoanAndGoInvesting()  
    }
  },

  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    ...mapActions('loan', [
      'addLoansOffersCurrent',
      'createLoan',
      'getLoansByOngoing',
      'getLoanAvailableTime',
    ]),
    ...mapActions('evaluation', ['addCreditEvaluations', 'isKcsAgreements', 'isHometaxAccounts', 'getCreditEvaluationsCurrent']),
    ...mapActions('kyc', ['addCdd', 'getMobileAuthUrl']),
    ...mapActions('document', ['getDocuments']),
    ...mapActions('contract', ['getLimitTransaction', 'checkExistContract', 'getCurrent']),
    ...mapActions('myfinbiz', ['getContractsAgreementsMyfinbizService']),

    async validateUserRequirements2() {
      // 본인인증 체크
      if(!this.me) {
        await this.getMe()
      }
      console.log('********* 본인인증 체크', this.me)
      if (!this.me.kyc.mobileVerificationIsDone) {
        const redirect = await this.getMobileAuthUrl({
          redirectPage: `${location.origin}/kyc/verify-id?from=pull-revenue`,
        })
        return locationRedirect(redirect)
      }

      console.log('********* 신분증 체크')
      // 신분증 인증 체크
      if (!this.fileObj) {
        await this.getDocuments()
      }
      if (!this.me.kyc.idCardVerificationIsDone) {
        return this.$router.replace({
          path: '/kyc/verify-id-card',
          query: { next: '/loan/pull-revenue-check' },
        })
      }

      console.log('********* 주거래은행 체크')
      // 주거래은행 체크
      if (!this.me.withdrawalAccount.accountNumber) {
        return this.$router.replace({
          path: '/signup/bank/withdrawal',
          query: { next: '/loan/pull-revenue-check' },
        })
      }

      // 사업자등록증 체크
      if (!this.fileObj.businessLicense) {
        return this.$router.replace({
          path: '/signup/documents',
          query: { next: '/loan/pull-revenue-check' },
        })
      }

      // 집금계좌 체크
      if (!this.me?.collectionAccount?.accountNumber) {
        return this.$router.replace({
          path: '/bank/collections',
          query: { next: '/loan/pull-revenue-check' },
        })
      }

      // 소득증명 체크
      if (!this.fileObj?.certificateOfIncomeAmount) {
        return this.$router.replace({
          path: '/signup/certification',
          query: { next: '/loan/pull-revenue-check' },
        })
      }


    },
    commaFormat,
    async createLoanAndGoInvesting() {
      if (this.requestLoanLoading) return
      try {
        this.requestLoanLoading = true

        // 신용인증 유효기간 만료면 신용인증으로?? --> 미리 체크 불가?
        if (this.isExpire) {
          const { isConfirmed } = await this.$swal.basic.confirm({
            html: '신용 인증 유효기간이 만료되어,<br> 신용 인증 페이지로 이동합니다',
          })
          if (!isConfirmed) {
            return
          }
          await this.addCreditEvaluations({
            redirectPath: `${this.$route.path}?requestProcess=true`,
          })
          return
        }

        // 대출 불가면 알림
        if (this.me.isLoanable !== true) {
          await this.$swal.basic.alert({
            html: '대출신청을 할 수 없습니다. 고객센터로 문의 주세요.',
          })
          return
        }

        // 론 생성 후 모집 페이지로 이동
        await this.createLoan(this.offer)
        await this.getLoansByOngoing()
        await this.$router.replace(`/loan/${this.investingPullRevenue.uuid}/investing`)
      } finally {
        this.requestLoanLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
